// @flow
import moment from "moment";

export function DatetoEndTimeAppend(date: Date): Date {
  return moment(date)
    .add(23, "h")
    .add(59, "m")
    .add(59, "s")
    .utc()
    .toISOString();
}

export function DatetoStartTimeAppend(date: Date): Date {
  return moment(date)
    .utc()
    .toISOString();
}

export function JsDateObjectDisplayDateOnly(date: Date): string {
  return moment
    .utc(date)
    .local()
    .format("DD/MMM/YYYY");
}

export function TodaytoEndTimeAppend(getIso?: boolean = false): Date {
  if (getIso) {
    return moment({ hour: 23, minute: 59, seconds: 59 })
      .utc()
      .toISOString();
  } else {
    return moment({ hour: 23, minute: 59, seconds: 59 });
  }
}

export function StartDatetoEndDate(
  date: Date,
  type: string,
  value: number
): Date {
  return moment(date)
    .add(value, type)
    .add(23, "h")
    .add(59, "m")
    .add(59, "s")
    .utc()
    .toISOString();
}

export function DaysBeforeTodayStartTimeAppend(
  type: string,
  days: number
): Date {
  return moment({ hour: 0, minute: 0, seconds: 0 })
    .add(-Math.abs(days), type)
    .utc()
    .toISOString();
}

export function DatabaseDateToJsDateISOString(date: Date): Date {
  return moment
    .utc(date)
    .local()
    .toISOString();
}

export function DateDiff(prevDate: Date, nextDate: Date, type: string): number {
  const aDate = moment(prevDate);
  const bDate = moment(nextDate);
  return bDate.diff(aDate, type);
}

export function isMomentBefore(
  compareDate: Date | null,
  baseDate: Date | moment
): boolean {
  if (compareDate === null) {
    return true;
  } else {
    if (moment.isMoment(baseDate)) {
      return moment(compareDate).isBefore(baseDate);
    } else {
      return moment(compareDate).isBefore(moment(baseDate));
    }
  }
}

export function isMomentAfter(
  compareDate: Date | null,
  baseDate: Date | moment
): boolean {
  if (compareDate === null) {
    return false;
  } else {
    if (moment.isMoment(baseDate)) {
      return moment(compareDate).isAfter(baseDate);
    } else {
      return moment(compareDate).isAfter(moment(baseDate));
    }
  }
}
